export class ObservationPermissions {
    OBS_Add: boolean = false;
    OBS_Add_Unit: boolean = false;
    OBS_Own: boolean = false;
    OBS_View_Unit: boolean = false;
    OBS_View: boolean = false;
    OBS_Admin_Unit: boolean = false;
    OBS_Admin: boolean = false;
    OBS_CAT_Add: boolean = false;
    OBS_CAT_Add_Unit: boolean = false;
    OBS_View_Observer: boolean = false;
}